import { render } from "./BlueDropdownMenu.vue?vue&type=template&id=5c82ab8a&scoped=true&ts=true"
import script from "./BlueDropdownMenu.vue?vue&type=script&lang=ts"
export * from "./BlueDropdownMenu.vue?vue&type=script&lang=ts"

import "./BlueDropdownMenu.vue?vue&type=style&index=0&id=5c82ab8a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c82ab8a"]])

export default __exports__